import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button, Form, FormGroup, Label, Input, Collapse } from "reactstrap";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { genderOptions } from "common/data/constants";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories, fetchDepartments, fetchDesignations, fetchLeaves, fetchEmployeeDropdown, fetchLeavePolicyRequest, resetAll, saveLeavePolicyRequest, } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import CustomDatePicker from "common/CustomDatePicker";
import Loader from "common/pageLoader";
import { useLocation, useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import Swal from "sweetalert2";

const twoDigitNumeric = /^\d{1,2}$/;
const threeDigitNumeric = /^\d{1,3}$/;

const LeavePolicy = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);
    const dispatch = useDispatch();
    const [authDetails, setAuthDetails] = useState(null);
    const {
        categories,
        departments,
        designations,
        leaves,
        dropdownData,
        leavePolicy,
        loading,
        error,
        success
    } = useSelector((state) => ({
        categories: state.CategoryMaster?.categories ?? [],
        departments: state.DepartmentMaster?.departments ?? [],
        designations: state.DesignationMaster?.designations ?? [],
        dropdownData: state.EmployeeDetailsReducer?.dropdownData ?? [],
        leaves: state.leaveReducer?.leaves ?? [],
        leavePolicy: state.EmpGracePolicyReducer?.leavePolicy ?? [],
        loading: state.EmpGracePolicyReducer?.loading || state.CategoryMaster?.loading || state.DepartmentMaster?.loading,
        error: state.EmpGracePolicyReducer?.error || state.CategoryMaster?.error || state.DepartmentMaster?.error,
        success: state.EmpGracePolicyReducer?.success || state.CategoryMaster?.success || state.DepartmentMaster?.success,
    }));
    const [empment_type, setempmentType] = useState([]);
    const [employeeTypeOptions, setemployeeTypes] = useState([]);

    useEffect(() => {
        dispatch(resetAll())
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchCategories(unitId));
        dispatch(fetchDepartments(unitId));
        dispatch(fetchDesignations(unitId));
        dispatch(fetchLeaves(unitId));
        dispatch(fetchEmployeeDropdown(unitId));
        dispatch(fetchLeavePolicyRequest(unitId));
    }, [dispatch]);

    useEffect(() => {
        if (success) {
            addFormik.resetForm();
        }
    }, [success])

    useEffect(() => {
        if (dropdownData && dropdownData.empment_type) {
            const empTypes = dropdownData.empment_type;
            const employeeTypes = empTypes.map(item => ({
                ...item,
                value: item['emptype_id'],
                label: item['emp_type'] || "-"
            }));
            setemployeeTypes(employeeTypes);
            setempmentType(empTypes);
        }
    }, [dropdownData]);

    // const [data, setData] = useState([
    //     { leavetype_id: "Casual Leave", from: "01 Jan 2025", till: "31 Dec 2025", category: "Manager", employmentType: "Trainee", gender: "Female", leaveDays: 2.0, leavePerMonth: 2.0, accumulationDays: "-", cycleDays: "-", accumulation: "No", eligibility: 2, laterEntry: "No", appliedBeforeDays: 0, },
    //     { leavetype_id: "Sick Leave", from: "01 Feb 2025", till: "31 Dec 2025", category: "Supervisor", employmentType: "Permanent", gender: "Male", leaveDays: 1.5, leavePerMonth: 1.5, accumulationDays: "-", cycleDays: "-", accumulation: "Yes", eligibility: 3, laterEntry: "No", appliedBeforeDays: 1, },
    //     { leavetype_id: "Maternity Leave", from: "01 Mar 2025", till: "31 Dec 2025", category: "Executive", employmentType: "Permanent", gender: "Female", leaveDays: 90, leavePerMonth: 7.5, accumulationDays: "-", cycleDays: "-", accumulation: "No", eligibility: 6, laterEntry: "Yes", appliedBeforeDays: 7, },
    //     { leavetype_id: "Paternity Leave", from: "01 Apr 2025", till: "31 Dec 2025", category: "Staff", employmentType: "Trainee", gender: "Male", leaveDays: 15, leavePerMonth: 1.25, accumulationDays: "-", cycleDays: "-", accumulation: "No", eligibility: 1, laterEntry: "No", appliedBeforeDays: 2, },
    //     { leavetype_id: "Earned Leave", from: "01 May 2025", till: "31 Dec 2025", category: "Manager", employmentType: "Remote", gender: "Female", leaveDays: 3.0, leavePerMonth: 0.25, accumulationDays: "-", cycleDays: "-", accumulation: "Yes", eligibility: 5, laterEntry: "Yes", appliedBeforeDays: 3, },
    //     { leavetype_id: "Compensatory Off", from: "01 Jun 2025", till: "31 Dec 2025", category: "Intern", employmentType: "Contract", gender: "Male", leaveDays: 0.0, leavePerMonth: 0.0, accumulationDays: "-", cycleDays: "-", accumulation: "No", eligibility: 0, laterEntry: "No", appliedBeforeDays: 0, },
    // ]);

    // const [filteredData, setFilteredData] = useState(data);
    const [activeAccordion, setActiveAccordion] = useState("search");

    const toggleAccordion = (accordionId) => {
        addFormik
        setActiveAccordion(activeAccordion === accordionId ? "" : accordionId);
        if (accordionId == "search") {
            dispatch(fetchLeavePolicyRequest(authDetails?.unit_id));
        }
    };
    const leaveTypeOptions = leaves.map(item => ({
        ...item,
        value: item['leavetypeid'],
        label: item['leavetype'] || "-"
    }));

    const categoryOptions = categories.map(item => ({
        ...item,
        value: item['empCatgryid'],
        label: item['empCategory'] || "-"
    }));

    const departmentOptions = departments.map(item => ({
        ...item,
        value: item['departmentId'],
        label: item['departmentcode'] || "-"
    }));

    const designationOptions = designations.map(item => ({
        ...item,
        value: item['desig_id'],
        label: item['designation'] || "-"
    }));

    const validationSchema = Yup.object().shape({
        leavetype_id: Yup.string().required("Leave Type is required"),
        // from_date: Yup.date().nullable(),
        // to_date: Yup.date().nullable().when("from_date", (from_date, schema) =>
        //     from_date ? schema.min(from_date, "Till Date must be after From Date") : schema
        // ),
        //leaveDays: Yup.number().nullable(),
        from_date: Yup.date()
            .nullable()
            .when("isApplicableForPeriod", {
                is: "Yes",
                then: Yup.date().required("From Date is required"),
                otherwise: Yup.date().nullable()
            }),

        to_date: Yup.date()
            .nullable()
            .when("isApplicableForPeriod", {
                is: "Yes",
                then: Yup.date()
                    .required("Till Date is required")
                    .when("from_date", (from_date, schema) =>
                        from_date
                            ? schema.min(from_date, "Till Date must be after From Date")
                            : schema
                    ),
                otherwise: Yup.date().nullable()
            }),
        category: Yup.array().of(Yup.string()),
        employmentType: Yup.array().of(Yup.string()),
        department: Yup.array().of(Yup.string()),
        designation: Yup.array().of(Yup.string()),
        // gender: Yup.array().of(Yup.string()).min(1, "Gender is required"),
        accumulation: Yup.string().required("Accumulation is required"),
        //eligibility: Yup.number().required("Eligibility is required"),
        //laterEntry: Yup.string().required("Later Entry is required"),
        appliedBeforeDays: Yup.number().required("Applied Before Days is required").min(0, "Must be at least 0").max(99, "Must be at least 99"),
        isApplicableForPeriod: Yup.string().required("Is Applicable for Period is required"),
        leavePerMonth: Yup.number().when("isApplicableForPeriod", {
            is: "No",
            then: (schema) => schema.required("Leave Per Month is required").min(0, "Must be at least 0").max(99, "Must be at least 99"),
            otherwise: (schema) => schema.notRequired(),
        }),
        totalLeaveDays: Yup.string().when("isApplicableForPeriod", {
            is: "No",
            then: (schema) =>
                schema
                    .required("Total Leave Days is required")
                    .matches(twoDigitNumeric, "Total Leave Days must be numeric and max 99 digits"),
            otherwise: (schema) => schema.notRequired(),
        }),
        cycleDays: Yup.string().when("isApplicableForPeriod", {
            is: "Yes",
            then: (schema) =>
                schema
                    .required("Cycle Days is required")
                    .matches(threeDigitNumeric, "Cycle Days must be numeric and max 999 digits"),
            otherwise: (schema) => schema.notRequired(),
        }),
        option: Yup.string().when("isApplicableForPeriod", {
            is: "Yes",
            then: (schema) => schema.required("Option is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        accumulationDays: Yup.number().when("isApplicableForPeriod", {
            is: "Yes",
            then: (schema) => schema.required("Accumulation Days is required").min(0, "Must be at least 0").max(999, "Must be at least 999"),
            otherwise: (schema) => schema.notRequired(),
        }),
        eligibilityOverConfirmed: Yup.number(),
        isPayable: Yup.string().required("Is Payable is required"),
        isCarryForwarded: Yup.string().required("Is Carry Forwarded is required"),
        carryForwardedTypeMonth: Yup.string(),
        carryForwardedTypeYear: Yup.string(),
        allowLaterEntry: Yup.string().required("Allow Later Entry is required"),
        isLop: Yup.string().required("Is LOP is required"),
        isPayslipReimbursement: Yup.string().required("Is Payslip Reimbursement is required"),
        includingHoliday: Yup.string().required("Including Holiday is required"),
        includingWeekoff: Yup.string().required("Including Weekoff is required"),
        showInDashboard: Yup.string().required("Show in Dashboard is required"),
        requiredAttachment: Yup.string().required("Required Attachment is required"),
        isEncashment: Yup.string().required("Is Encashment is required"),
    }).test("at-least-one-group", "At least one of Category, Employment Type, Department, or Designation must be selected", function (values) {
        const { category, employmentType, department, designation } = values;
        return (
            (category && category.length > 0) ||
            (employmentType && employmentType.length > 0) ||
            (department && department.length > 0) ||
            (designation && designation.length > 0)
        );
    }).test("carry-forwarded-type", "Select at least one carry forward type", function (values) {
        if (values.isCarryForwarded === "Yes") {
            return values.carryForwardedTypeMonth !== "0" || values.carryForwardedTypeYear !== "0";
        }
        return true;
    });

    const initialValues = {
        leavetype_id: "",
        from_date: "",
        to_date: "",
        category: "",
        employmentType: "",
        gender: "",
        leaveDays: "",
        leavePerMonth: "",
        accumulation: "",
        //eligibility: "",
        //laterEntry: "",
        appliedBeforeDays: "",
        isApplicableForPeriod: "No",
        cycleDays: "",
        option: "",
        eligibilityOverConfirmed: "0",
        isPayable: "Yes",
        isCarryForwarded: "",
        includingWeekoff: "",
        accumulationDays: "",
        totalLeaveDays: "",
        allowLaterEntry: "",
        isLop: "No",
        isPayslipReimbursement: "",
        includingHoliday: "",
        showInDashboard: "",
        requiredAttachment: "",
        isEncashment: "",
        carryForwardedTypeMonth: "0",
        carryForwardedTypeYear: "0",
    };

    const addFormik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        validateOnChange: false,
        validateOnBlur: true,
        onSubmit: async (values, { setTouched }) => {
            // const newEntry = {
            //     id: data.length + 1,
            //     leavetype_id: values.leavetype_id,
            //     from: values.from_date,
            //     till: values.to_date,
            //     category: values.category,
            //     employmentType: values.employmentType,
            //     gender: values.gender,
            //     leaveDays: values.leaveDays,
            //     leavePerMonth: values.leavePerMonth,
            //     accumulationDays: values.accumulationDays,
            //     cycleDays: values.cycleDays,
            //     accumulation: values.accumulation,
            //     eligibility: values.eligibility,
            //     laterEntry: values.laterEntry,
            //     appliedBeforeDays:values.appliedBeforeDays,
            // }; 
            console.log(values)

            const yesNo = (val) => (val === "Yes" ? 1 : 0);

            const formData = new FormData();
            formData.append("unit_id", authDetails?.unit_id);
            formData.append("create_by", authDetails?.user_id);

            formData.append("leavetype_id", values.leavetype_id || 0);
            formData.append("gender_id", (values.gender || []).join(",") || 0);
            formData.append("emptype_id", (values.employmentType || []).join(",") || 0);
            formData.append("from_date", values.from_date || "");
            formData.append("to_date", values.to_date || "");
            formData.append("applied_days", values.leaveDays || 0);
            formData.append("total_leave_days", values.totalLeaveDays || 0);
            formData.append("leave_per_Month", values.leavePerMonth || 0);
            formData.append("accumulation_day", values.accumulationDays || 0);
            formData.append("cycle_day", values.cycleDays || 0);
            formData.append("accumulation", yesNo(values.accumulation) || 0);

            formData.append("eligiblity_based_confirmation", yesNo(values.eligibilityOverConfirmed));
            formData.append("allow_Later_entry", yesNo(values.allowLaterEntry));
            formData.append("is_payable", yesNo(values.isPayable));
            formData.append("is_lop", yesNo(values.isLop));
            formData.append("is_encash", yesNo(values.isEncashment));
            formData.append("is_carry_forwarded", yesNo(values.isCarryForwarded));
            formData.append("is_applicable", yesNo(values.isApplicableForPeriod));
            formData.append("is_payslip_reimbursement", yesNo(values.isPayslipReimbursement));
            formData.append("is_show_dashboard", yesNo(values.showInDashboard));
            formData.append("is_weekoff", yesNo(values.includingWeekoff));
            formData.append("is_holiday", yesNo(values.includingHoliday));
            formData.append("is_attachment", yesNo(values.requiredAttachment));

            formData.append("to_be_appliedbeforedays", values.appliedBeforeDays || 0);
            formData.append("calendarworking_days", values.carryForwardedTypeMonth || "");
            formData.append("cat_id", (values.category || []).join(","));
            formData.append("dept_id", (values.department || []).join(","));
            formData.append("desig_id", (values.designation || []).join(","));

            dispatch(saveLeavePolicyRequest(formData))
        }
    });

    const handleCancel = async (e) => {
        e.preventDefault();

        const hasChanges = addFormik.dirty;

        if (!hasChanges) {
            addFormik.resetForm();
            return;
        }

        const result = await Swal.fire({
            title: "Confirm Cancel",
            text: "All entered data will be cleared. Do you want to continue?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            confirmButtonColor: "rgb(145, 73, 234)",
            cancelButtonColor: "#6c757d",
        });

        if (!result.isConfirmed) return;

        addFormik.resetForm();
    };

    // const searchFormik = useFormik({
    //     initialValues: {
    //         leavetype_id: "",
    //         category: "",
    //         department: "",
    //     },
    //     validationSchema: Yup.object({
    //         leavetype_id: Yup.string().required("Leave Type is required"),
    //         category: Yup.string().required("Category is required"),
    //         department: Yup.string().required("Department is required"),
    //     }),
    //     onSubmit: (values) => {
    //         const filtered = data.filter((record) => {
    //             return (
    //                 (!values.leavetype_id || record.leavetype_id.toLowerCase() === values.leavetype_id.toLowerCase()) &&
    //                 (!values.category || record.category.toLowerCase() === values.category.toLowerCase())
    //             );
    //         });
    //         setFilteredData(filtered);
    //     },
    // });

    const columns = [
        {
            Header: "S.No",
            Cell: ({ row }) => leavePolicy.length - row.index,
            className: "serial-no",
            applyHeaderClass: true,
        },
        { Header: "Leave Type", accessor: "leave_type" },
        { Header: "From Date", accessor: "from_date" },
        { Header: "To Date", accessor: "to_date" },
        { Header: "Category", accessor: "category" },
        { Header: "Department", accessor: "department" },
        { Header: "Designation", accessor: "designation" },
        { Header: "Employment Type", accessor: "emp_type" },
        { Header: "Gender", accessor: "gender_name" },
        { Header: "Leave Days", accessor: "total_leave_days" },
        { Header: "Leave Per Month", accessor: "leave_per_Month" },
        { Header: "Accumulation", accessor: "accumulation" },
        { Header: "Accumulation Days", accessor: "accumulation_day" },
        { Header: "Cycle Days", accessor: "cycle_day" },
        { Header: "Eligibility", accessor: "eligiblity_based_confirmation" },
        { Header: "Later Entry", accessor: "allow_Later_entry" },
        { Header: "Applied Before Days", accessor: "to_be_appliedbeforedays" },
        { Header: "Is Applicable", accessor: "is_applicable" },
        { Header: "Is Payable", accessor: "is_payable" },
        { Header: "LOP", accessor: "is_lop" },
        { Header: "Carry Forward", accessor: "is_carry_forwarded" },
        { Header: "Is Encashment", accessor: "is_encash" },
        { Header: "Payslip Reimbursement", accessor: "is_payslip_reimbursement" },
        { Header: "Show Dashboard", accessor: "is_show_dashboard" },
        { Header: "Weekoff", accessor: "is_weekoff" },
        { Header: "Holiday", accessor: "is_holiday" },
        { Header: "Attachment", accessor: "is_attachment" },
    ];

    // select custome style
    const SelectcustomStyles = {
        control: (base) => ({
            ...base,
            maxheight: 33.1,
            minHeight: 33.1,
            // overflow: "scroll",
        }),
        indicatorsContainer: (base) => ({
            ...base,
            padding: "0", // Match the padding for both dropdown and clear indicator
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: "2px 8px", // Ensure consistent padding for dropdown indicator
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
        }),
    };

    useEffect(() => {
        addFormik.setFieldValue('accumulation', addFormik.values.isApplicableForPeriod);
    }, [addFormik.values.isApplicableForPeriod]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Loader loading={loading} />
                <Container fluid>
                    <Breadcrumbs title="Policy Setup" breadcrumbItem="Leave Policy" />
                    <Card><CardBody>

                        {/* Accordion for Add and Search */}
                        <div className="accordion accordion-flush" id="accordionFlushExample">
                            {/* Add Section */}
                            {canCreate && (
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingAdd">
                                        <button className={`fs-16 accordion-button ${activeAccordion === "add" ? "" : "collapsed"}`} type="button" onClick={() => toggleAccordion("add")} style={{ cursor: "pointer" }} > Add </button>
                                    </h2>
                                    <Collapse isOpen={activeAccordion === "add"}>
                                        <div className="accordion-body">
                                            <Form onSubmit={addFormik.handleSubmit}>
                                                <Row className="gy-2">
                                                    {/* Leave Type */}
                                                    <Col lg={3} sm="6" md="4" >
                                                        <FormGroup>
                                                            <Label for="leavetype_id">Leave Type <span className="text-danger">*</span></Label>
                                                            <Select
                                                                styles={SelectcustomStyles}
                                                                id="leavetype_id"
                                                                options={leaveTypeOptions}
                                                                value={leaveTypeOptions.find(opt => opt.value === addFormik.values.leavetype_id) || null}
                                                                onChange={(option) => addFormik.setFieldValue("leavetype_id", option?.value || "")}
                                                                isClearable
                                                                className="hrms-select"
                                                                classNamePrefix="hrms-select"
                                                                onBlur={() => addFormik.setFieldTouched("leavetype_id", true)}
                                                            />
                                                            {addFormik.touched.leavetype_id && addFormik.errors.leavetype_id && (
                                                                <div className="text-danger">{addFormik.errors.leavetype_id}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* Gender */}
                                                    <Col lg={3} sm="6" md="4">
                                                        <FormGroup>
                                                            <Label for="gender">Gender</Label>
                                                            <Select
                                                                styles={SelectcustomStyles}
                                                                id="gender"
                                                                name="gender"
                                                                options={genderOptions}
                                                                value={genderOptions.filter(opt => addFormik.values.gender?.includes(opt.value))}
                                                                onChange={(selectedOptions) => {
                                                                    const values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                                                                    addFormik.setFieldValue("gender", values);
                                                                }}
                                                                isClearable
                                                                className="hrms-select"
                                                                classNamePrefix="hrms-select"
                                                                onBlur={() => addFormik.setFieldTouched("gender", true)}
                                                                isMulti
                                                            />
                                                            {addFormik.touched.gender && addFormik.errors.gender && (
                                                                <div className="text-danger">{addFormik.errors.gender}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* From Date */}
                                                    <Col lg={3} sm="6" md="2">
                                                        <FormGroup>
                                                            <Label>
                                                                From Date {" "}
                                                                {addFormik.values.isApplicableForPeriod === "Yes" && (
                                                                    <span className="text-danger">*</span>
                                                                )}
                                                            </Label>
                                                            <CustomDatePicker
                                                                name="from_date"
                                                                value={addFormik.values.from_date}
                                                                onChange={(val) => addFormik.setFieldValue("from_date", val)}
                                                                onBlur={() => addFormik.setFieldTouched("from_date", true)}
                                                            />
                                                            {addFormik.touched.from_date && addFormik.errors.from_date && (
                                                                <div className="text-danger mt-1">{addFormik.errors.from_date}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>

                                                    {/* To Date */}
                                                    <Col lg={3} sm="6" md="2">
                                                        <FormGroup>
                                                            <Label>
                                                                To Date{" "}
                                                                {addFormik.values.isApplicableForPeriod === "Yes" && (
                                                                    <span className="text-danger">*</span>
                                                                )}
                                                            </Label>
                                                            <CustomDatePicker
                                                                name="to_date"
                                                                value={addFormik.values.to_date}
                                                                onChange={(val) => addFormik.setFieldValue("to_date", val)}
                                                                onBlur={() => addFormik.setFieldTouched("to_date", true)}
                                                            />
                                                            {addFormik.touched.to_date && addFormik.errors.to_date && (
                                                                <div className="text-danger mt-1">{addFormik.errors.to_date}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* Category */}
                                                    <Col lg={3} sm="6" md="6">
                                                        <FormGroup>
                                                            <Label for="category">Category</Label>
                                                            <Select
                                                                styles={SelectcustomStyles}
                                                                id="category"
                                                                options={categoryOptions}
                                                                value={categoryOptions.filter(opt => addFormik.values.category?.includes(opt.value))}
                                                                onChange={(selectedOptions) => {
                                                                    let values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                                                                    if (values.includes(0) && values.length > 1) {
                                                                        values = [0];
                                                                    }
                                                                    addFormik.setFieldValue("category", values);
                                                                }}
                                                                isClearable
                                                                className="hrms-select"
                                                                classNamePrefix="hrms-select"
                                                                onBlur={() => addFormik.setFieldTouched("category", true)}
                                                                isMulti
                                                            />
                                                            {addFormik.touched.category && addFormik.errors.category && (
                                                                <div className="text-danger">{addFormik.errors.category}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* Employee Type */}
                                                    <Col lg={3} sm="6" md="6">
                                                        <FormGroup>
                                                            <Label for="employeeType">Employee Type</Label>
                                                            <Select
                                                                styles={SelectcustomStyles}
                                                                id="employeeType"
                                                                options={employeeTypeOptions}
                                                                value={employeeTypeOptions.filter(opt => addFormik.values.employmentType?.includes(opt.value))}
                                                                onChange={(selectedOptions) => {
                                                                    let values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                                                                    if (values.includes(0) && values.length > 1) {
                                                                        values = [0];
                                                                    }
                                                                    addFormik.setFieldValue("employmentType", values);
                                                                }}
                                                                isClearable
                                                                className="hrms-select"
                                                                classNamePrefix="hrms-select"
                                                                onBlur={() => addFormik.setFieldTouched("employmentType", true)}
                                                                isMulti
                                                            />
                                                            {addFormik.touched.employmentType && addFormik.errors.employmentType && (
                                                                <div className="text-danger">{addFormik.errors.employmentType}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* Department */}
                                                    <Col lg={3} sm="6" md="6">
                                                        <FormGroup>
                                                            <Label for="department">Department</Label>
                                                            <Select
                                                                styles={SelectcustomStyles}
                                                                id="department"
                                                                options={departmentOptions}
                                                                value={departmentOptions.filter(opt => addFormik.values.department?.includes(opt.value))}
                                                                onChange={(selectedOptions) => {
                                                                    let values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                                                                    if (values.includes(0) && values.length > 1) {
                                                                        values = [0];
                                                                    }
                                                                    addFormik.setFieldValue("department", values);
                                                                }}
                                                                isClearable
                                                                className="hrms-select"
                                                                classNamePrefix="hrms-select"
                                                                onBlur={() => addFormik.setFieldTouched("department", true)}
                                                                isMulti
                                                            />
                                                            {addFormik.touched.department && addFormik.errors.department && (
                                                                <div className="text-danger">{addFormik.errors.department}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* Designation */}
                                                    <Col lg={3} sm="6" md="6">
                                                        <FormGroup>
                                                            <Label for="designation">Designation</Label>
                                                            <Select
                                                                styles={SelectcustomStyles}
                                                                id="designation"
                                                                options={designationOptions}
                                                                value={designationOptions.filter(opt => addFormik.values.designation?.includes(opt.value))}
                                                                onChange={(selectedOptions) => {
                                                                    let values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                                                                    if (values.includes(0) && values.length > 1) {
                                                                        values = [0];
                                                                    }
                                                                    addFormik.setFieldValue("designation", values);
                                                                }}
                                                                isClearable
                                                                className="hrms-select"
                                                                classNamePrefix="hrms-select"
                                                                onBlur={() => addFormik.setFieldTouched("designation", true)}
                                                                isMulti
                                                            />
                                                            {addFormik.touched.designation && addFormik.errors.designation && (
                                                                <div className="text-danger">{addFormik.errors.designation}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    <hr />
                                                    {/* Is Applicable for Period */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="isApplicableForPeriod">Is Applicable for Period?</Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input
                                                                    type="radio"
                                                                    id="isApplicableYes"
                                                                    name="isApplicableForPeriod"
                                                                    value="Yes"
                                                                    checked={addFormik.values.isApplicableForPeriod === "Yes"}
                                                                    onChange={(e) => {
                                                                        addFormik.handleChange(e);
                                                                        const value = e.target.value;
                                                                        addFormik.setFieldValue("accumulation", value);
                                                                        addFormik.setFieldValue("accumulationDays", "");
                                                                        addFormik.setFieldValue("cycleDays", "");
                                                                    }}
                                                                    onBlur={addFormik.handleBlur}
                                                                />{" "} Yes

                                                                <Input
                                                                    type="radio"
                                                                    id="isApplicableNo"
                                                                    name="isApplicableForPeriod"
                                                                    value="No"
                                                                    checked={addFormik.values.isApplicableForPeriod === "No"}
                                                                    onChange={(e) => {
                                                                        addFormik.handleChange(e);
                                                                        const value = e.target.value;
                                                                        addFormik.setFieldValue("accumulation", value);
                                                                        addFormik.setFieldValue("accumulationDays", "");
                                                                        addFormik.setFieldValue("cycleDays", "");
                                                                    }}
                                                                    onBlur={addFormik.handleBlur}
                                                                    className="ms-3"
                                                                />{" "} No
                                                            </div>
                                                            {addFormik.touched.isApplicableForPeriod && addFormik.errors.isApplicableForPeriod && (
                                                                <div className="text-danger">{addFormik.errors.isApplicableForPeriod}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* Is Accumulative */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="isAccumulative">Is Accumulative?</Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="accumulativeYes" name="accumulation" value="Yes" checked={addFormik.values.isApplicableForPeriod === "Yes"} disabled />{" "} Yes
                                                                <Input type="radio" id="accumulativeNo" name="accumulation" value="No" checked={addFormik.values.isApplicableForPeriod === "No"} disabled className="ms-3" />{" "} No
                                                            </div>
                                                        </FormGroup>
                                                    </Col>

                                                    {addFormik.values.isApplicableForPeriod === "Yes" && (
                                                        <>
                                                            {/* Accumulation Days */}
                                                            <Col md="2" sm="6" lg="3">
                                                                <FormGroup>
                                                                    <Label for="accumulationDays">Accumulation Days</Label>
                                                                    <Input type="number" id="accumulationDays" maxLength={3} name="accumulationDays" value={addFormik.values.accumulationDays} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} disabled={addFormik.values.isApplicableForPeriod === "No"} />
                                                                    {addFormik.touched.accumulationDays && addFormik.errors.accumulationDays && (
                                                                        <div className="text-danger">{addFormik.errors.accumulationDays}</div>
                                                                    )}
                                                                </FormGroup>
                                                            </Col>
                                                            {/* Cycle Days */}
                                                            <Col md="2" sm="6" lg="3">
                                                                <FormGroup>
                                                                    <Label for="cycleDays">Cycle Days</Label>
                                                                    <Input type="number" id="cycleDays" name="cycleDays" maxLength={3} value={addFormik.values.cycleDays} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} disabled={addFormik.values.isApplicableForPeriod === "No"} />
                                                                    {addFormik.touched.cycleDays && addFormik.errors.cycleDays && (
                                                                        <div className="text-danger">{addFormik.errors.cycleDays}</div>
                                                                    )}
                                                                </FormGroup>
                                                            </Col>

                                                            {/* Option */}
                                                            <Col md="4" sm="6" lg="3">
                                                                <FormGroup>
                                                                    <Label for="option">Option</Label>
                                                                    <div className="d-flex align-items-center gap-2 min-height-42">
                                                                        <Input type="radio" id="workingDays" name="option" value="Working Days" checked={addFormik.values.option === "Working Days"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} disabled={addFormik.values.isApplicableForPeriod === "No"} />{" "}
                                                                        Working Days
                                                                        <Input type="radio" id="calendarDays" name="option" value="Calendar Days" checked={addFormik.values.option === "Calendar Days"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} className="ms-3" disabled={addFormik.values.isApplicableForPeriod === "No"} />{" "}
                                                                        Calendar Days
                                                                    </div>
                                                                    {addFormik.touched.option && addFormik.errors.option && (
                                                                        <div className="text-danger">{addFormik.errors.option}</div>
                                                                    )}
                                                                </FormGroup>
                                                            </Col>
                                                        </>)}

                                                    {addFormik.values.isApplicableForPeriod === "No" && (
                                                        <>
                                                            {/* Total Leave Days */}
                                                            <Col md="2" sm="6" lg="3">
                                                                <FormGroup>
                                                                    <Label for="totalLeaveDays">Total Leave Days <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        type="number"
                                                                        id="totalLeaveDays"
                                                                        name="totalLeaveDays"
                                                                        maxLength={2}
                                                                        value={addFormik.values.totalLeaveDays}
                                                                        onChange={addFormik.handleChange}
                                                                        onBlur={addFormik.handleBlur}
                                                                        disabled={addFormik.values.isApplicableForPeriod === "Yes"}
                                                                    />
                                                                    {addFormik.touched.totalLeaveDays && addFormik.errors.totalLeaveDays && (
                                                                        <div className="text-danger">{addFormik.errors.totalLeaveDays}</div>
                                                                    )}
                                                                </FormGroup>
                                                            </Col>
                                                            {/* Leave Per Month */}
                                                            <Col md="2" sm="6" lg="3">
                                                                <FormGroup>
                                                                    <Label for="leavePerMonth">Leave Per Month <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        type="number"
                                                                        id="leavePerMonth"
                                                                        name="leavePerMonth"
                                                                        maxLength={2}
                                                                        value={addFormik.values.leavePerMonth}
                                                                        onChange={addFormik.handleChange}
                                                                        onBlur={addFormik.handleBlur}
                                                                        disabled={addFormik.values.isApplicableForPeriod === "Yes"}
                                                                    />
                                                                    {addFormik.touched.leavePerMonth && addFormik.errors.leavePerMonth && (
                                                                        <div className="text-danger">{addFormik.errors.leavePerMonth}</div>
                                                                    )}
                                                                </FormGroup>
                                                            </Col>
                                                        </>)}
                                                    {/* Eligibility Over Confirmed (Months) */}
                                                    <Col md="4" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="eligibilityOverConfirmed">
                                                                Eligibility Over Confirmed (Days)
                                                            </Label>
                                                            <Input
                                                                type="number"
                                                                id="eligibilityOverConfirmed"
                                                                name="eligibilityOverConfirmed"
                                                                maxLength={2}
                                                                value={addFormik.values.eligibilityOverConfirmed}
                                                                onChange={addFormik.handleChange}
                                                                onBlur={addFormik.handleBlur}
                                                                disabled={addFormik.values.isApplicableForPeriod === "Yes"}
                                                            />
                                                            {addFormik.touched.eligibilityOverConfirmed && addFormik.errors.eligibilityOverConfirmed && (
                                                                <div className="text-danger">{addFormik.errors.eligibilityOverConfirmed}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>

                                                    {/* Allow Later Entry */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="allowLaterEntry">Allow Later Entry <span className="text-danger">*</span></Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="laterEntryYes" name="allowLaterEntry" value="Yes" checked={addFormik.values.allowLaterEntry === "Yes"}
                                                                    onChange={() => {
                                                                        addFormik.setFieldValue("appliedBeforeDays", 0);
                                                                        addFormik.setFieldValue("allowLaterEntry", 'Yes');
                                                                    }}
                                                                    onBlur={addFormik.handleBlur} />
                                                                {" "} Yes
                                                                <Input type="radio" id="laterEntryNo" name="allowLaterEntry" value="No" checked={addFormik.values.allowLaterEntry === "No"} onChange={() => {
                                                                    addFormik.setFieldValue("appliedBeforeDays", 1);
                                                                    addFormik.setFieldValue("allowLaterEntry", 'No');
                                                                }} onBlur={addFormik.handleBlur} className="ms-3" />
                                                                {" "} No
                                                            </div>
                                                            {addFormik.touched.allowLaterEntry && addFormik.errors.allowLaterEntry && (
                                                                <div className="text-danger">{addFormik.errors.allowLaterEntry}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* To be Applied Before Days */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="appliedBeforeDays">To be Applied Before Days <span className="text-danger">*</span></Label>
                                                            <Input type="number" id="appliedBeforeDays" name="appliedBeforeDays" maxLength={2} value={addFormik.values.appliedBeforeDays} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} disabled={addFormik.values.allowLaterEntry === "Yes"} />
                                                            {addFormik.touched.appliedBeforeDays && addFormik.errors.appliedBeforeDays && (
                                                                <div className="text-danger">{addFormik.errors.appliedBeforeDays}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* Is Payable */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="isPayable">Is Payable?</Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="isPayableYes" name="isPayable" value="Yes" checked={addFormik.values.isPayable === "Yes"} onChange={() => {
                                                                    addFormik.setFieldValue("isLop", 'No');
                                                                    addFormik.setFieldValue("isPayable", 'Yes');
                                                                }} onBlur={addFormik.handleBlur} />{" "} Yes
                                                                <Input type="radio" id="isPayableNo" name="isPayable" value="No" checked={addFormik.values.isPayable === "No"} onChange={() => {
                                                                    addFormik.setFieldValue("isLop", 'Yes');
                                                                    addFormik.setFieldValue("isPayable", 'No');
                                                                }} onBlur={addFormik.handleBlur} className="ms-3" />{" "} No
                                                            </div>
                                                            {addFormik.touched.isPayable && addFormik.errors.isPayable && (
                                                                <div className="text-danger">{addFormik.errors.isPayable}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {/* Is LOP */}
                                                    <Col md="4" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="isLop">Is LOP?</Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="lopYes" name="isLop" value="Yes" checked={addFormik.values.isLop === "Yes"} onChange={() => {
                                                                    addFormik.setFieldValue("isLop", 'Yes');
                                                                    addFormik.setFieldValue("isPayable", 'No');
                                                                }} onBlur={addFormik.handleBlur} />{" "} Yes
                                                                <Input type="radio" id="lopNo" name="isLop" value="No" checked={addFormik.values.isLop === "No"} onChange={() => {
                                                                    addFormik.setFieldValue("isLop", 'No');
                                                                    addFormik.setFieldValue("isPayable", 'Yes');
                                                                }} onBlur={addFormik.handleBlur} className="ms-3" />{" "} No
                                                            </div>
                                                            {addFormik.touched.isLop && addFormik.errors.isLop && (
                                                                <div className="text-danger">{addFormik.errors.isLop}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    <hr />

                                                    {/* Is Carry Forwarded */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="isCarryForwarded">Is Carry Forwarded? <span className="text-danger">*</span></Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="carryForwardedYes" name="isCarryForwarded" value="Yes" checked={addFormik.values.isCarryForwarded === "Yes"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} />{" "} Yes
                                                                <Input type="radio" id="carryForwardedNo" name="isCarryForwarded" value="No" checked={addFormik.values.isCarryForwarded === "No"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} className="ms-3" />{" "} No
                                                            </div>
                                                            {addFormik.touched.isCarryForwarded && addFormik.errors.isCarryForwarded && (
                                                                <div className="text-danger">{addFormik.errors.isCarryForwarded}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>

                                                    {addFormik.values.isCarryForwarded === "Yes" && (<>
                                                        {/* Is Carry Forwarded */}
                                                        <Col md="2" sm="6" lg="3">
                                                            <FormGroup>
                                                                <Label for="isCarryForwarded">Carry Forwarded Types</Label>
                                                                <div className="d-flex align-items-center gap-2 min-height-42">
                                                                    <Input type="checkbox" id="carryForwardedTypeMonth" name="carryForwardedTypeMonth" value="1" checked={addFormik.values.carryForwardedTypeMonth === "1"} onChange={(e) => addFormik.setFieldValue("carryForwardedTypeMonth", e.target.checked ? "1" : "0")} onBlur={addFormik.handleBlur} />{" "} Monthly

                                                                    <Input type="checkbox" id="carryForwardedTypeYear" name="carryForwardedTypeYear" value="1" checked={addFormik.values.carryForwardedTypeYear === "1"} onChange={(e) => addFormik.setFieldValue("carryForwardedTypeYear", e.target.checked ? "1" : "0")} onBlur={addFormik.handleBlur} className="ms-3" />{" "} Yearly
                                                                </div>

                                                                {addFormik.touched.isCarryForwarded && addFormik.errors.isCarryForwarded && (
                                                                    <div className="text-danger">{addFormik.errors.isCarryForwarded}</div>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </>)}

                                                    {/* Is Encashment */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="isEncashment">Is Encashment? <span className="text-danger">*</span></Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="isEncashmentYes" name="isEncashment" value="Yes" checked={addFormik.values.isEncashment === "Yes"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} />{" "} Yes
                                                                <Input type="radio" id="isEncashmentNo" name="isEncashment" value="No" checked={addFormik.values.isEncashment === "No"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} className="ms-3" />{" "} No
                                                            </div>
                                                            {addFormik.touched.isEncashment && addFormik.errors.isEncashment && (
                                                                <div className="text-danger">{addFormik.errors.isEncashment}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>

                                                    {/* Is Payslip Reimbursement */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="isPayslipReimbursement"> Is Payslip Reimbursement? <span className="text-danger">*</span></Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="reimbursementYes" name="isPayslipReimbursement" value="Yes" checked={addFormik.values.isPayslipReimbursement === "Yes"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} />{" "} Yes

                                                                <Input type="radio" id="reimbursementNo" name="isPayslipReimbursement" value="No" checked={addFormik.values.isPayslipReimbursement === "No"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} className="ms-3" />{" "} No
                                                            </div>
                                                            {addFormik.touched.isPayslipReimbursement && addFormik.errors.isPayslipReimbursement && (
                                                                <div className="text-danger">{addFormik.errors.isPayslipReimbursement}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>

                                                    {/* Show in Dashboard */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="showInDashboard">Is Visible in Dashboard? <span className="text-danger">*</span></Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="showInDashboardYes" name="showInDashboard" value="Yes" checked={addFormik.values.showInDashboard === "Yes"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} />{" "} Yes
                                                                <Input type="radio" id="showInDashboardNo" name="showInDashboard" value="No" checked={addFormik.values.showInDashboard === "No"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} className="ms-3" />{" "} No
                                                            </div>
                                                            {addFormik.touched.showInDashboard && addFormik.errors.showInDashboard && (
                                                                <div className="text-danger">{addFormik.errors.showInDashboard}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>

                                                    {/* Including Weekoff */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="includingWeekoff">Including Weekoff <span className="text-danger">*</span></Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="weekoffYes" name="includingWeekoff" value="Yes" checked={addFormik.values.includingWeekoff === "Yes"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} />{" "} Yes
                                                                <Input type="radio" id="weekoffNo" name="includingWeekoff" value="No" checked={addFormik.values.includingWeekoff === "No"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} className="ms-3" />{" "} No
                                                            </div>
                                                            {addFormik.touched.includingWeekoff && addFormik.errors.includingWeekoff && (
                                                                <div className="text-danger">{addFormik.errors.includingWeekoff}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>

                                                    {/* Including Holiday */}
                                                    <Col md="2" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="includingHoliday">Including Holiday <span className="text-danger">*</span></Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="holidayYes" name="includingHoliday" value="Yes" checked={addFormik.values.includingHoliday === "Yes"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} />{" "} Yes
                                                                <Input type="radio" id="holidayNo" name="includingHoliday" value="No" checked={addFormik.values.includingHoliday === "No"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} className="ms-3" />{" "} No
                                                            </div>
                                                            {addFormik.touched.includingHoliday && addFormik.errors.includingHoliday && (
                                                                <div className="text-danger">{addFormik.errors.includingHoliday}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>

                                                    {/* Required Attachment */}
                                                    <Col md="3" sm="6" lg="3">
                                                        <FormGroup>
                                                            <Label for="requiredAttachment">Is Document Required? <span className="text-danger">*</span></Label>
                                                            <div className="d-flex align-items-center gap-2 min-height-42">
                                                                <Input type="radio" id="requiredAttachmentYes" name="requiredAttachment" value="Yes" checked={addFormik.values.requiredAttachment === "Yes"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} />{" "} Yes
                                                                <Input type="radio" id="requiredAttachmentNo" name="requiredAttachment" value="No" checked={addFormik.values.requiredAttachment === "No"} onChange={addFormik.handleChange} onBlur={addFormik.handleBlur} className="ms-3" />{" "} No
                                                            </div>
                                                            {addFormik.touched.requiredAttachment && addFormik.errors.requiredAttachment && (
                                                                <div className="text-danger">{addFormik.errors.requiredAttachment}</div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3">
                                                    <Col md={12} className="text-end mob-center">
                                                        {/* {Object.keys(addFormik.errors).length > 0 && addFormik.submitCount > 0 && (
                                                    <div className="alert alert-danger">
                                                        <ul className="mb-0">
                                                            {Object.entries(addFormik.errors).map(([key, value]) => (
                                                                <li key={key}>{value}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )} */}
                                                        <Button type="submit" className="btn button-save  me-2">
                                                            <i className="fas fa-save me-1" /> Save
                                                        </Button>
                                                        <Button type="button" className="btn button-cancel" onClick={handleCancel}><i className="fas fa-sync me-1" />Cancel</Button>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </div>
                                    </Collapse>
                                </div>
                            )}
                            {(canRead || canCreate || canEdit || canDelete) && (
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingSearch">
                                        <button className={`fs-16 accordion-button ${activeAccordion === "search" ? "" : "collapsed"}`}
                                            onClick={() => toggleAccordion("search")}>Search</button>
                                    </h2>
                                    <Collapse isOpen={activeAccordion === "search"}>
                                        <div className="accordion-body">
                                            {/* <Form onSubmit={searchFormik.handleSubmit}>
                                        <Row className="gy-2">
                                         
                                        <Col md="3" sm="6" >
                                            <FormGroup>
                                            <Label>Leave Type</Label>
                                            <Select
                                                styles={SelectcustomStyles}
                                                id="leavetype_id"
                                                options={leaveTypeOptions}
                                                value={leaveTypeOptions.find(opt => opt.value === searchFormik.values.leavetype_id) || null}
                                                onChange={(option) => searchFormik.setFieldValue("leavetype_id", option?.value || "")}
                                                isClearable
                                                onBlur={() => searchFormik.setFieldTouched("leavetype_id", true)}
                                            />
                                            {searchFormik.touched.leavetype_id && searchFormik.errors.leavetype_id && (
                                                <div className="text-danger">{searchFormik.errors.leavetype_id}</div>
                                            )}
                                            </FormGroup>
                                        </Col>
 
                                        <Col md="3" sm="6" >
                                            <FormGroup>
                                            <Label>Category</Label>
                                            <Select
                                                styles={SelectcustomStyles}
                                                id="category"
                                                options={categoryOptions}
                                                value={categoryOptions.find(opt => opt.value === searchFormik.values.category) || null}
                                                onChange={(option) => searchFormik.setFieldValue("category", option?.value || "")}
                                                isClearable
                                                onBlur={() => searchFormik.setFieldTouched("category", true)}
                                            />
                                            {searchFormik.touched.category && searchFormik.errors.category && (
                                                <div className="text-danger">{searchFormik.errors.category}</div>
                                            )}
                                            </FormGroup>
                                        </Col> 
                                        <Col md="3" sm="6" >
                                            <FormGroup>
                                            <Label>Department</Label>
                                            <Select
                                                styles={SelectcustomStyles}
                                                id="department"
                                                options={[
                                                { value: "All", label: "All" },
                                                { value: "HR", label: "HR" },
                                                { value: "Finance", label: "Finance" },
                                                ]}
                                                value={searchFormik.values.department ?
                                                { value: searchFormik.values.department, label: searchFormik.values.department } :
                                                null
                                                }
                                                onChange={(option) => searchFormik.setFieldValue("department", option?.value || "")}
                                                isClearable
                                                onBlur={() => searchFormik.setFieldTouched("department", true)}
                                            />
                                            {searchFormik.touched.department && searchFormik.errors.department && (
                                                <div className="text-danger">{searchFormik.errors.department}</div>
                                            )}
                                            </FormGroup>
                                        </Col>
 
                                        <Col md="3" sm="6"  className="d-flex align-items-center">
                                            <div>
                                            <Button type="submit" color="primary" className="me-2">
                                                Search
                                            </Button>
                                            <Button
                                                type="button"
                                                color="secondary"
                                                onClick={() => {
                                                searchFormik.resetForm();
                                                setFilteredData(data); // Reset table data
                                                }}>
                                                Cancel
                                            </Button>
                                            </div>
                                        </Col>
                                        </Row>
                                    </Form> */}

                                            {/* Results Table */}
                                            <Row className="mt-3 leave-table">
                                                <TableContainer columns={columns} data={leavePolicy.length > 0 ? leavePolicy : []} isGlobalFilter={true} customPageSize={10} />
                                            </Row>
                                        </div>
                                    </Collapse>
                                </div>
                            )}
                        </div>
                    </CardBody></Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default LeavePolicy;
